function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgCoupe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M36.782,142.419c12.152-13.258,24.886-25.188,38.907-36.264c1.649-1.302,4.023,0.257,3.471,2.284 c-7.859,28.885-21.59,57.431-42.757,78.652C35.452,172.235,35.438,157.255,36.782,142.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M36.404,187.102c-12.221-14.748-22.723-29.996-32.185-46.458c-1.082-1.882-3.96-1.211-4.07,0.958 c-1.707,33.721,11.177,73.177,42.567,89.091C39.588,216.353,37.334,201.76,36.404,187.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M42.714,230.682c7.691-15.825,16.3-30.548,26.391-44.819c1.197-1.693,3.882-0.917,3.969,1.155 c1.229,29.129-3.769,59.921-17.726,85.491C50.174,258.899,45.81,244.919,42.714,230.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M55.351,272.519c-15.869-10.199-30.365-21.35-44.27-33.876c-1.604-1.445-4.12,0.064-3.577,2.153 c8.377,32.209,32.333,65.262,66.439,71.1C66.853,299.236,60.502,286.095,55.351,272.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M73.937,311.887c2.78-17.264,6.756-33.733,12.291-50.198c0.658-1.958,3.439-1.996,4.129-0.048 c9.68,27.328,13.601,58.159,7.761,86.493C89.24,336.644,81.027,324.569,73.937,311.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M98.124,348.143c-18.089-5.125-35.179-11.534-52.104-19.39c-1.955-0.908-3.915,1.268-2.788,3.105 c17.402,28.379,49.982,52.949,84.297,48.715C116.995,370.481,107.041,359.7,98.124,348.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M127.521,380.566c-2.468-17.394-3.517-34.359-3.032-51.798c0.057-2.067,2.709-2.914,3.937-1.25 c17.332,23.498,30.262,52.042,33.356,80.981C149.73,400.029,138.158,390.771,127.521,380.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M475.218,142.419c-12.152-13.258-24.886-25.188-38.907-36.264c-1.649-1.302-4.023,0.257-3.471,2.284 c7.859,28.885,21.59,57.431,42.757,78.652C476.548,172.235,476.562,157.255,475.218,142.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M475.596,187.102c12.221-14.748,22.723-29.996,32.185-46.458c1.082-1.882,3.96-1.211,4.07,0.958 c1.707,33.721-11.177,73.177-42.567,89.091C472.412,216.353,474.666,201.76,475.596,187.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M469.286,230.682c-7.691-15.825-16.3-30.548-26.391-44.819c-1.197-1.693-3.882-0.917-3.969,1.155 c-1.229,29.129,3.769,59.921,17.726,85.491C461.826,258.899,466.19,244.919,469.286,230.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M456.649,272.519c15.869-10.199,30.365-21.35,44.27-33.876c1.604-1.445,4.12,0.064,3.577,2.153 c-8.377,32.209-32.333,65.262-66.439,71.1C445.147,299.236,451.498,286.095,456.649,272.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M438.063,311.887c-2.78-17.264-6.756-33.733-12.291-50.198c-0.658-1.958-3.439-1.996-4.129-0.048 c-9.68,27.328-13.601,58.159-7.761,86.493C422.76,336.644,430.973,324.569,438.063,311.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M413.876,348.143c18.089-5.125,35.179-11.534,52.104-19.39c1.955-0.908,3.915,1.268,2.788,3.105 c-17.402,28.379-49.982,52.949-84.297,48.715C395.005,370.481,404.959,359.7,413.876,348.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M384.479,380.566c2.468-17.394,3.517-34.359,3.032-51.798c-0.057-2.067-2.709-2.914-3.937-1.25 c-17.332,23.498-30.262,52.042-33.356,80.981C362.27,400.029,373.842,390.771,384.479,380.566z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7BC14"
    },
    d: "M204.103,424.371c-13.849-6.829-26.508-14.259-37.627-22.081c-0.003-0.002-0.005-0.003-0.008-0.005 c-0.002-0.001-0.003-0.003-0.005-0.004c-12.409-8.72-23.597-17.839-33.257-27.106c-0.002-0.002-0.004-0.005-0.006-0.007 c-10.843-10.386-20.451-20.98-28.559-31.489c-0.002-0.003-0.005-0.006-0.007-0.009c-0.001-0.001-0.001-0.002-0.002-0.003 c-9.146-11.838-17.049-23.681-23.489-35.203c-0.003-0.006-0.007-0.011-0.01-0.017c-7.304-13.047-13.377-25.906-18.049-38.222 c-0.002-0.005-0.004-0.009-0.006-0.013v-0.001c-5.336-14.041-9.465-27.707-12.274-40.619c0-0.002-0.001-0.003-0.001-0.004 c-3.225-14.785-5.288-29.022-6.131-42.313c0-0.007-0.002-0.013-0.002-0.019c-0.98-15.307-0.858-29.897,0.363-43.364 c0.015-0.163,0.015-0.325,0.019-0.487c1.612-20.825,5.467-41.7,11.477-62.057c1.208-4.093-1.131-8.39-5.224-9.598 c-4.091-1.209-8.39,1.129-9.598,5.224c-6.381,21.615-10.46,43.794-12.123,65.921c-0.011,0.151-0.008,0.299-0.011,0.448 c-1.222,14.022-1.337,29.12-0.326,44.903c0,0.003,0,0.005,0,0.008c0.892,14.055,3.061,29.055,6.448,44.586 c0.003,0.012,0.004,0.025,0.006,0.037c2.971,13.66,7.321,28.069,12.93,42.824l0,0c0.001,0.002,0.001,0.004,0.002,0.006 c4.943,13.028,11.341,26.585,19.017,40.294c0.001,0.002,0.002,0.004,0.003,0.006c0.003,0.005,0.005,0.009,0.008,0.013 c0,0,0,0,0.001,0.001l0,0c6.811,12.18,15.134,24.66,24.74,37.094c0.004,0.005,0.008,0.008,0.011,0.013 c8.571,11.107,18.69,22.271,30.077,33.18c0.003,0.003,0.005,0.006,0.008,0.009c10.225,9.811,22.028,19.436,35.082,28.609 c0.002,0.001,0.003,0.002,0.005,0.003l0,0c11.768,8.281,25.12,16.121,39.683,23.303c1.1,0.542,2.265,0.799,3.412,0.799 c2.849,0,5.591-1.583,6.936-4.311C209.503,430.892,207.93,426.259,204.103,424.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7BC14"
    },
    d: "M482.427,143.343c-0.003-0.149,0-0.296-0.011-0.446c-1.663-22.131-5.742-44.311-12.123-65.922 c-1.208-4.092-5.504-6.426-9.599-5.223c-4.093,1.208-6.431,5.506-5.223,9.599c6.009,20.352,9.864,41.226,11.477,62.053 c0.005,0.163,0.005,0.326,0.02,0.49c1.221,13.462,1.343,28.053,0.363,43.366c0,0.003,0,0.006,0,0.008 c0,0.003-0.001,0.005-0.001,0.008c-0.843,13.285-2.906,27.521-6.132,42.313c0,0.001-0.001,0.003-0.001,0.004 c-2.807,12.912-6.937,26.578-12.274,40.618c-0.001,0.002-0.001,0.003-0.002,0.005c-0.001,0.004-0.003,0.007-0.005,0.01 c-4.671,12.315-10.746,25.178-18.056,38.235c-0.001,0.001-0.002,0.003-0.003,0.004c-6.439,11.519-14.342,23.362-23.49,35.203 c-0.002,0.003-0.004,0.006-0.006,0.009c-0.001,0.001-0.001,0.001-0.002,0.002c-8.105,10.505-17.715,21.099-28.559,31.489 c-0.002,0.002-0.004,0.005-0.006,0.007c-9.656,9.264-20.846,18.384-33.258,27.106c-0.003,0.002-0.006,0.005-0.01,0.008 c-0.001,0-0.002,0.001-0.003,0.001c-11.119,7.824-23.778,15.253-37.627,22.081c-3.828,1.887-5.401,6.52-3.513,10.347 c1.345,2.73,4.086,4.312,6.936,4.312c1.147,0,2.312-0.257,3.411-0.799c14.561-7.18,27.911-15.019,39.679-23.299 c0.004-0.003,0.008-0.004,0.012-0.007c13.056-9.176,24.859-18.801,35.081-28.609c0.003-0.003,0.005-0.006,0.008-0.009 c11.392-10.916,21.514-22.082,30.083-33.188c0.001,0,0.001-0.001,0.002-0.002s0.002-0.002,0.003-0.003 c9.611-12.442,17.939-24.927,24.749-37.108c0.005-0.008,0.008-0.016,0.012-0.024c7.674-13.708,14.069-27.259,19.006-40.275 c0-0.001,0.001-0.001,0.001-0.003c0-0.001,0.001-0.001,0.001-0.003c5.606-14.747,9.953-29.147,12.924-42.801 c0.001-0.003,0.002-0.005,0.003-0.008c3.393-15.557,5.566-30.575,6.458-44.639c0.001-0.011,0-0.021,0-0.031 C483.763,172.442,483.648,157.352,482.427,143.343z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB125"
    },
    d: "M212.092,296.012c-22.276,0.001-43.988-7.892-61.265-22.594 c-21.314-18.138-33.539-44.588-33.539-72.567v-26.128c0-3.02,1.178-5.86,3.316-7.993c2.131-2.125,4.961-3.295,7.969-3.295 c0.01,0,0.02,0,0.03,0l68.408,0.15c4.267,0.009,7.719,3.476,7.71,7.744c-0.01,4.261-3.468,7.71-7.726,7.71 c-0.006,0-0.012,0-0.018,0l-64.235-0.141l-0.001,21.952c0,23.44,10.242,45.6,28.1,60.797c17.721,15.08,41.018,21.603,63.905,17.89 c0.794-0.129,1.593-0.264,2.4-0.405c4.208-0.729,8.208,2.075,8.944,6.278c0.736,4.204-2.075,8.208-6.278,8.944 c-0.871,0.152-1.736,0.299-2.593,0.438C222.18,295.61,217.12,296.012,212.092,296.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB125"
    },
    d: "M299.908,296.012c-5.03,0-10.086-0.402-15.128-1.219c-0.857-0.139-1.722-0.286-2.593-0.438 c-4.204-0.736-7.014-4.741-6.278-8.944c0.736-4.204,4.745-7.009,8.944-6.278c0.806,0.142,1.606,0.277,2.4,0.405 c22.892,3.71,46.184-2.81,63.905-17.89c17.858-15.196,28.1-37.356,28.1-60.797v-21.952l-64.235,0.141c-0.006,0-0.012,0-0.018,0 c-4.259,0-7.717-3.448-7.726-7.71c-0.01-4.268,3.442-7.735,7.71-7.744l68.411-0.15c0.01,0,0.02,0,0.03,0 c3.006,0,5.835,1.169,7.967,3.295c2.138,2.134,3.316,4.972,3.316,7.993v26.128c0,27.979-12.224,54.429-33.539,72.567 C343.897,288.119,322.183,296.012,299.908,296.012z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED130"
    },
    d: "M205.195,407.993h101.609c-42.089-53.374-37.697-130.296-37.697-130.296H256h-13.107 C242.893,277.698,247.285,354.62,205.195,407.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7BC14"
    },
    d: "M269.107,277.698H256h-13.107c0,0,0.68,11.943-1.069,29.681 c-3.334,33.811,5.053,67.919,24.841,95.536c1.228,1.714,2.5,3.408,3.817,5.078h36.323 C264.715,354.62,269.107,277.698,269.107,277.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED130"
    },
    d: "M179.353,141.293v67.411c0,39.882,18.955,77.39,51.064,101.046l0,0 c15.214,11.208,35.952,11.208,51.166,0l0,0c32.109-23.655,51.064-61.164,51.064-101.046v-67.411L179.353,141.293L179.353,141.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7BC14"
    },
    d: "M296.152,141.293v67.411c0,39.882-18.955,77.39-51.064,101.046l0,0 c-2.329,1.716-4.788,3.166-7.336,4.356c14.098,6.587,30.945,5.137,43.83-4.356l0,0c32.109-23.655,51.064-61.164,51.064-101.046 v-67.411L296.152,141.293L296.152,141.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB125"
    },
    d: "M338.138,151.823H173.862c-2.476,0-4.483-2.007-4.483-4.483v-18.578c0-2.476,2.007-4.483,4.483-4.483 h164.276c2.476,0,4.483,2.007,4.483,4.483v18.578C342.62,149.816,340.613,151.823,338.138,151.823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M338.138,124.28h-32.012v27.543h32.012c2.476,0,4.482-2.007,4.482-4.483v-18.578 C342.62,126.287,340.613,124.28,338.138,124.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB125"
    },
    d: "M343.164,440.569h-173.64c-2.517,0-4.264-2.507-3.392-4.868l12.895-34.94 c0.524-1.421,1.878-2.364,3.392-2.364h147.85c1.514,0,2.868,0.943,3.392,2.364l12.895,34.94 C347.428,438.062,345.681,440.569,343.164,440.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M346.557,435.701l-12.895-34.94c-0.525-1.421-1.878-2.364-3.393-2.364h-35.266l15.564,42.172h32.597 C345.681,440.569,347.428,438.062,346.557,435.701z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupe);
export default __webpack_public_path__ + "static/media/coupe.3dbb66c9cc839f878e2a1bf7e124b01f.svg";
export { ForwardRef as ReactComponent };